import * as React from 'react';
import { Flex } from '../../../designSystem/compositeComponents/FlexHelpers';
import { Pill, PillWrapper } from '../../../designSystem/pill/Pill';
import { Button } from '../../../designSystem/button/Button';
import { TextInput } from '../../../designSystem/inputs/TextInput';
import { Survey, fieldValidation } from '../../../amorg-common';
import { updateSurveyQuestion } from '../../../api/surveyClientApi';
import { Label } from '../../../designSystem/Label';
import { Modal } from '../../../designSystem/Modal';
import { InputMessage } from '../../../designSystem/InputMessage';
import { basicValidation } from '../../../amorg-common/modules/fieldValidation/basicValidation';

type IndicatorListProps = {
    survey:Survey,
    themeIndex:number,
    questionIndex:number,
    allIndicators:string[],
    selectedIndicators:string[],
    disableEdit?:boolean,
    onChange:()=>void
}
export function IndicatorEditor(props:IndicatorListProps):JSX.Element
{
    const [showModal, setShowModal] = React.useState(false);

    async function handleSaveIndicators(indicators:string[])
    {
        const question = props.survey.themes[props.themeIndex].questions[props.questionIndex];
        await updateSurveyQuestion(props.survey.id, props.themeIndex, props.questionIndex, indicators.sort(), question.title, question.canComment);
        props.onChange();
        setShowModal(false);
    }


    return (
        <div>
            {props.selectedIndicators.length > 0 &&
                <Flex alignItems='center'>
                    <Label>
                        Indikatorer
                    </Label>   
                </Flex>
            }
            <Flex flexDirection="column" gap={16}>

                <Flex flexDirection="row" gap={10} flexWrap="wrap" alignItems='center'>

                    {props.selectedIndicators.sort().map((v) =>
                        <Pill key={v}
                            identifier={v}>
                            <span>{v}</span>
                        </Pill>
                    )}
                    {props.selectedIndicators.length === 0 &&
                        <i>Ingen indikatorer valgt</i>
                    }
                    <Button variant='text' icon='interface_actions_edit' onClick={()=>setShowModal(true)}></Button>
                    
                </Flex>
                <IndicatorModal 
                    questionTitle={props.survey.themes[props.themeIndex].questions[props.questionIndex].title}
                    allIndicators={props.allIndicators}
                    selectedIndicators={props.selectedIndicators}
                    show={showModal}
                    onSaveIndicators={handleSaveIndicators}
                    onClose={()=>setShowModal(false)} />
            </Flex>
        </div>
    );
}

type IndicatorModalProps = {
    questionTitle:string,
    allIndicators:string[],
    selectedIndicators:string[]
    show:boolean,
    onSaveIndicators:(indicators:string[])=>void,
    onClose:()=>void
}
function IndicatorModal(props:IndicatorModalProps):JSX.Element
{
    const [allIndicators, setAllIndicators] = React.useState<string[]>([]);
    const [selectedIndicators, setSelectedIndicators] = React.useState<string[]>([]);
    const [newTag, setNewTag] = React.useState('');
    const [error, setError] = React.useState('');

    // Reinitialize every time modal is show
    React.useEffect(()=>{
        setAllIndicators(props.allIndicators);
        setSelectedIndicators(props.selectedIndicators);
    },[props.show]);

    function handleClickIndicatorPill(identifier?:string)
    {
        if(selectedIndicators.includes(identifier))
            setSelectedIndicators(selectedIndicators.filter(v => v !== identifier));
        else
            setSelectedIndicators([...selectedIndicators, identifier]);
    }

    function handleClickAdd()
    {
        if(fieldValidation.surveyQuestion.indicator(newTag) && basicValidation.arrayStringsAreUnique([...allIndicators, newTag]))
        {
            setAllIndicators([...allIndicators, newTag]);
            setSelectedIndicators([...selectedIndicators, newTag]);
            setNewTag('');
            setError('');
        }
        else
            setError('Ugyldig tekst. Skal udfyldes med et unikt navn på maks. 50 tegn');
    }

    return (


        <Modal 
                title={"Vælg indikatorer"}
                content={
                    <Flex flexDirection='column' gap={32} style={{marginTop:'16px'}}>
                <div>
                    {props.allIndicators.length === 0 &&
                        <p>Der er ikke oprettet nogen indikatorer. Med indikatorer kan du gruppere spørgsmål på tværs af temaer. Indikatorer redigeres for spørgsmål individuelt.</p>
                    }
                    <PillWrapper>
                        {allIndicators.map(ai =>
                            <Pill key={ai} identifier={ai}
                                variant={selectedIndicators.includes(ai) ? 'selected' : 'default'}
                                button={{
                                    icon:selectedIndicators.includes(ai) ? 'actions_close' : 'actions_plus',
                                    onClick:(handleClickIndicatorPill)
                                }}>
                                {ai}
                            </Pill>
                        )}
                    </PillWrapper>
                </div>

                <Flex flexDirection='column' gap={5}>
                    <Label>Opret ny indikator</Label>
                    <TextInput
                        placeholder='Ny indikator...'
                        value={newTag} 
                        onChange={(value) => setNewTag(value)} />
                    <Flex justifyContent='flex-end'>
                        {error!=='' && 
                            <div style={{flexGrow:1}}>
                                <InputMessage inErrorState={true}>{error}</InputMessage>
                            </div>
                        }
                        <Button variant='filled' onClick={handleClickAdd} text='Opret'></Button>
                    </Flex>
                </Flex>

                <Flex flexDirection='row' justifyContent="space-between">
                    <Button variant='text' onClick={()=>props.onClose()} text='Annuller'></Button>
                    <Button variant='filled' onClick={()=>props.onSaveIndicators(selectedIndicators)} text='Gem'></Button>
                </Flex>
            </Flex>
                }
                showModal={props.show}
                onCancel={()=>props.onClose()}/>


    );
}